export const PROCESS_DIRECTORY_URL = "/processes/?view=all";
const PROCESS_FAVOURITES_STORAGE_KEY = "clank.processes.favourites";

export const readFavouriteProcessSlugs = (): string[] => {
  try {
    const raw = window.localStorage.getItem(PROCESS_FAVOURITES_STORAGE_KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return [];
    return [
      ...new Set(parsed.filter((slug): slug is string => typeof slug === "string" && !!slug)),
    ];
  } catch {
    return [];
  }
};

export const persistFavouriteProcessSlugs = (slugs: string[]) => {
  try {
    window.localStorage.setItem(PROCESS_FAVOURITES_STORAGE_KEY, JSON.stringify(slugs));
  } catch {}
};

// Optional directory columns in display order; the process name column is always shown.
export const PROCESS_COLUMNS = [
  "people",
  "tools",
  "cases",
  "avgDuration",
  "medianDuration",
  "shareOfTeam",
  "timeInApp",
  "totalTime",
  "steps",
  "lastObserved",
] as const;
export type ProcessColumn = (typeof PROCESS_COLUMNS)[number];
// Shown only under the grouping that measures them (see GROUPING_CONTEXT); on by default.
const GROUPING_COLUMNS = ["shareOfTeam", "timeInApp"] as const;
export type GroupingColumn = (typeof GROUPING_COLUMNS)[number];
export const isGroupingColumn = (column: ProcessColumn): column is GroupingColumn =>
  (GROUPING_COLUMNS as readonly ProcessColumn[]).includes(column);
export const DEFAULT_PROCESS_COLUMNS: readonly ProcessColumn[] = [
  "people",
  "cases",
  "avgDuration",
  "shareOfTeam",
  "timeInApp",
  "totalTime",
  "lastObserved",
];
const PROCESS_COLUMNS_STORAGE_KEY = "clank.processes.columns";

export const readProcessColumns = (): readonly ProcessColumn[] => {
  try {
    const parsed: unknown = JSON.parse(
      window.localStorage.getItem(PROCESS_COLUMNS_STORAGE_KEY) ?? "null",
    );
    return Array.isArray(parsed)
      ? PROCESS_COLUMNS.filter(column => parsed.includes(column))
      : DEFAULT_PROCESS_COLUMNS;
  } catch {
    return DEFAULT_PROCESS_COLUMNS;
  }
};

export const persistProcessColumns = (columns: readonly ProcessColumn[]) => {
  try {
    window.localStorage.setItem(PROCESS_COLUMNS_STORAGE_KEY, JSON.stringify(columns));
  } catch {}
};

export const readRecentProcessSlugs = (viewerId: string): string[] => {
  try {
    const value: unknown = JSON.parse(
      window.localStorage.getItem(`clank.processes.recent.${viewerId}`) ?? "[]",
    );
    return Array.isArray(value)
      ? value.filter((slug): slug is string => typeof slug === "string").slice(0, 5)
      : [];
  } catch {
    return [];
  }
};

export const rememberProcess = (viewerId: string, slug: string) => {
  try {
    window.localStorage.setItem(
      `clank.processes.recent.${viewerId}`,
      JSON.stringify(
        [slug, ...readRecentProcessSlugs(viewerId).filter(value => value !== slug)].slice(0, 5),
      ),
    );
  } catch {}
};
